export default __webpack_public_path__ + "static/Economic Model Whitepaper - Turkish-b7a618811a1a032a594a834b53d082e9.pdf";